const domReady = () => {
    const toggles = document.querySelectorAll('.toggle');

    toggles.forEach(toggle => {

        toggle.querySelectorAll('a.button-block').forEach(toggleButton => {

            toggleButton.addEventListener('click', (e) => {

                e.preventDefault();

                // Remove active state from buttons in this toggle group
                toggle.querySelectorAll('a.button-block').forEach(button => {
                    button.classList.remove('button-block--active');
                });

                // Activate clicked button
                toggleButton.classList.add('button-block--active');

                // Get href
                const href = toggleButton.getAttribute('href');

                // Stop if href is invalid
                if (!href || !href.startsWith('#')) {
                    return;
                }

                const toggleContentId = href.substring(1);

                // Hide all targets
                document.querySelectorAll('.toggle-group').forEach(target => {
                    target.classList.remove('toggle-active');
                });

                // Show matching targets
                document.querySelectorAll(`.toggle-target-${toggleContentId}`).forEach(target => {
                    target.classList.add('toggle-active');
                });

            });

        });

    });
}

document.addEventListener('DOMContentLoaded', domReady);